/* eslint-disable react/prop-types */
import './UserTable.scss';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrashCan } from '@fortawesome/free-regular-svg-icons';
import {
  faSort,
  faSortUp,
  faSortDown,
} from '@fortawesome/free-solid-svg-icons';

const gsT = (t, key) => t(`shared${key}`);

function TableHeaderItem({ label, onClick, orderIcon }) {
  return (
    <th>
      <button type="button" className="sortable" onClick={onClick}>
        {label}
        <FontAwesomeIcon className="sort-icon" icon={orderIcon ?? faSort} />
      </button>
    </th>
  );
}

export default function UserTable({ children, sortByName, order, t }) {
  const [arrowIcon, setArrowIcon] = useState();

  const onSort = () => {
    setArrowIcon(order === 'asc' ? faSortUp : faSortDown);
  };

  return (
    <table className="user-table">
      <thead>
        <tr>
          <TableHeaderItem
            label={gsT(t, '.labels.name')}
            onClick={() => {
              sortByName();
              onSort();
            }}
            orderIcon={arrowIcon}
          />
          <th>{gsT(t, '.labels.email')}</th>
          <th>{gsT(t, '.labels.user-role')}</th>
          <th>{gsT(t, '.labels.settings')}</th>
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  );
}

function ItemButton({ icon, onClick }) {
  return (
    <button className="user-table-item-button" type="button" onClick={onClick}>
      <FontAwesomeIcon icon={icon} />
    </button>
  );
}

UserTable.Item = function Item({
  user,
  onEditClick,
  onDeleteClick,
  allowDelete,
  t,
}) {
  return (
    <tr className="user-item-wrapper">
      <td>{user.name}</td>
      <td>{user.email}</td>
      <td>
        {
          {
            0: gsT(t, '.user-roles.user'),
            1: gsT(t, '.user-roles.admin'),
            2: gsT(t, '.user-roles.integrated'),
            10: gsT(t, '.user-roles.system-admin'),
          }[user.role]
        }
      </td>
      <td>
        <ItemButton icon={faPenToSquare} onClick={onEditClick} />
        {allowDelete && (
          <ItemButton icon={faTrashCan} onClick={onDeleteClick} />
        )}
      </td>
    </tr>
  );
};
